module.exports = __webpack_public_path__ + "img/help15_modal_multispecies.deae041d.png";